(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    // Sort: native select (mobile bar drawer)
  document.querySelectorAll('[data-sort-select]').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  // Sort: custom dropdown buttons (desktop topbar)
  document.querySelectorAll('[data-sort-value]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', btn.dataset.sortValue);
      window.location.href = url.toString();
    });
  });

  // Price range slider
  function cfInitSliders() {
    document.querySelectorAll('[data-slider-wrap]').forEach(function(wrap) {
      if (wrap.dataset.sliderInited) return;
      wrap.dataset.sliderInited = '1';

      var minR  = wrap.querySelector('[data-slider-min]');
      var maxR  = wrap.querySelector('[data-slider-max]');
      var fill  = wrap.querySelector('[data-slider-fill]');
      var block = wrap.closest('[data-price-block]');
      if (!minR || !maxR || !fill || !block) return;

      var minLbl = block.querySelector('[data-slider-min-label]');
      var maxLbl = block.querySelector('[data-slider-max-label]');
      var minHid = block.querySelector('[data-slider-min-input]');
      var maxHid = block.querySelector('[data-slider-max-input]');
      var lo = parseFloat(minR.min), hi = parseFloat(maxR.max);
      var gap = Math.max(1, (hi - lo) * 0.005);

      // Slider values are already in display currency (÷100 done in Liquid)
      function fmt(v) { return Math.round(v).toLocaleString(); }

      function refresh() {
        var a = parseFloat(minR.value), b = parseFloat(maxR.value);
        var loPct = (a - lo) / (hi - lo) * 100;
        var hiPct = (b - lo) / (hi - lo) * 100;
        fill.style.left  = loPct + '%';
        fill.style.width = (hiPct - loPct) + '%';
        if (minLbl) minLbl.textContent = fmt(a);
        if (maxLbl) maxLbl.textContent = fmt(b);
        // Submit display-currency values — Shopify expects display units in filter URL
        if (minHid) minHid.value = Math.round(a);
        if (maxHid) maxHid.value = Math.round(b);
      }

      minR.addEventListener('input', function() {
        if (parseFloat(minR.value) > parseFloat(maxR.value) - gap)
          minR.value = parseFloat(maxR.value) - gap;
        minR.style.zIndex = 5; maxR.style.zIndex = 4;
        refresh();
      });
      maxR.addEventListener('input', function() {
        if (parseFloat(maxR.value) < parseFloat(minR.value) + gap)
          maxR.value = parseFloat(minR.value) + gap;
        maxR.style.zIndex = 5; minR.style.zIndex = 4;
        refresh();
      });

      // Default: max on top (so it's grabbable when both are at max)
      maxR.style.zIndex = 5; minR.style.zIndex = 4;
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cfInitSliders);
  } else {
    cfInitSliders();
  }

  // Re-init when a dropdown opens (slider may be inside closed <details>)
  document.querySelectorAll('[data-cf-dd]').forEach(function(dd) {
    dd.addEventListener('toggle', function() { if (dd.open) cfInitSliders(); });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customers-address-fields"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.customers-province-trigger').forEach(function (trigger) {
    var countrySel = document.getElementById(trigger.dataset.countryId);
    var provinceSel = document.getElementById(trigger.dataset.provinceId);
    var provinceCont = document.getElementById(trigger.dataset.provinceContId);
    var defaultProvince = trigger.dataset.defaultProvince;

    if (!countrySel || !provinceSel || !provinceCont) return;

    function updateProvinces() {
      var selectedOption = countrySel.options[countrySel.selectedIndex];
      var raw = selectedOption ? selectedOption.getAttribute('data-provinces') : null;
      var provinceData = raw ? JSON.parse(raw) : [];

      if (provinceData.length > 0) {
        provinceSel.innerHTML = '';
        provinceData.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p[0];
          opt.textContent = p[1];
          if (p[0] === defaultProvince) opt.selected = true;
          provinceSel.appendChild(opt);
        });
        provinceCont.style.display = '';
      } else {
        provinceCont.style.display = 'none';
      }
    }

    countrySel.addEventListener('change', updateProvinces);
    updateProvinces();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__locSelectorReady) return;
    window.__locSelectorReady = true;

    function setupSelector(selector) {
      var btn = selector.querySelector('.loc-trigger');
      var panel = selector.querySelector('.loc-panel');
      if (!btn || !panel) return;

      /* panel opens upward by default (footer); add --down if near top of page */
      function updateDirection() {
        var rect = btn.getBoundingClientRect();
        if (rect.top < 300) {
          panel.classList.add('loc-panel--down');
        } else {
          panel.classList.remove('loc-panel--down');
        }
      }

      function open() {
        updateDirection();
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }

      function close() {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }

      function toggle() {
        if (panel.hasAttribute('hidden')) { open(); } else { close(); }
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        /* close all other open selectors first */
        document.querySelectorAll('[data-loc-selector]').forEach(function (s) {
          if (s !== selector) {
            var p = s.querySelector('.loc-panel');
            var b = s.querySelector('.loc-trigger');
            if (p) p.setAttribute('hidden', '');
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
        toggle();
      });

      /* close on Escape */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); btn.focus(); }
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); btn.focus(); }
      });
    }

    function init() {
      document.querySelectorAll('[data-loc-selector]').forEach(setupSelector);
    }

    /* close when clicking outside */
    document.addEventListener('click', function () {
      document.querySelectorAll('[data-loc-selector]').forEach(function (selector) {
        var panel = selector.querySelector('.loc-panel');
        var btn = selector.querySelector('.loc-trigger');
        if (panel) panel.setAttribute('hidden', '');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pcReady) return;
    window.__pcReady = true;

    /* ---- Image reveal ---- */
    function revealImg(img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load',  function () { img.classList.add('is-loaded'); });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); });
      }
    }

    document.querySelectorAll('.pc-img1').forEach(revealImg);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('pc-img1')) revealImg(node);
          node.querySelectorAll('.pc-img1').forEach(revealImg);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    /* ---- AJAX add-to-cart ---- */
    var CART  = '<svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>';
    var CHECK = '<svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>';

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.closest('.pc-card')) return;
      e.preventDefault();

      var btn = form.querySelector('.pc-atc-btn');
      if (btn && btn.disabled) return;
      if (btn) { btn.disabled = true; btn.innerHTML = CHECK; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function () { return fetch('/cart.json'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badge = document.getElementById('cart-count');
          if (badge && cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.classList.remove('hidden');
          }
          document.dispatchEvent(new CustomEvent('lokatan:cart:open', { detail: cart }));
          setTimeout(function () {
            if (btn) { btn.innerHTML = CART; btn.disabled = false; }
          }, 1500);
        })
        .catch(function () {
          if (btn) { btn.innerHTML = CART; btn.disabled = false; }
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
